import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "o-container" }
const _hoisted_2 = { class: "o-title-2 c-course__section-title" }
const _hoisted_3 = { class: "c-tabs -course c-course" }
const _hoisted_4 = {
  key: 0,
  class: "c-tabs-nav__wrap",
  role: "tablist"
}
const _hoisted_5 = { class: "c-tabs-nav-mobile" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico arrow-left",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-left"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-left" })
], -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico arrow-right",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-right"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-right" })
], -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "o-container" }
const _hoisted_11 = { class: "c-tabs-nav" }
const _hoisted_12 = ["aria-selected", "onClick"]
const _hoisted_13 = { class: "c-tab" }
const _hoisted_14 = {
  key: 0,
  class: "c-tab__suptitle"
}
const _hoisted_15 = { class: "c-tab__title" }
const _hoisted_16 = { class: "c-tabs-content__wrap" }
const _hoisted_17 = ["hidden"]
const _hoisted_18 = { class: "o-container -container-full" }
const _hoisted_19 = { class: "c-tab-content" }
const _hoisted_20 = {
  key: 0,
  class: "c-course__filter"
}
const _hoisted_21 = { class: "c-course__filter__left" }
const _hoisted_22 = { class: "o-title-3" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "c-course__filter__right" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "o-title-5 c-course__filter__title" }, "Filtres", -1 /* HOISTED */)
const _hoisted_27 = { class: "c-course__filter__select" }
const _hoisted_28 = { class: "o-form__item" }
const _hoisted_29 = ["value"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_31 = {
  key: 0,
  class: "o-form__item"
}
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -ico-arrow-down",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
], -1 /* HOISTED */)
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 1,
  class: "c-course__text"
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 2,
  class: "c-course__list"
}
const _hoisted_39 = { class: "c-course__item" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 1,
  class: "c-course__header"
}
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "c-course__tags" }
const _hoisted_51 = {
  key: 0,
  class: "c-tag"
}
const _hoisted_52 = {
  key: 1,
  class: "c-tag"
}
const _hoisted_53 = {
  key: 0,
  class: "c-tag -bold"
}
const _hoisted_54 = { class: "c-tooltip" }
const _hoisted_55 = { class: "c-tooltip__text" }
const _hoisted_56 = { class: "c-tooltip__title" }
const _hoisted_57 = { class: "o-p" }
const _hoisted_58 = {
  key: 2,
  class: "c-course__prerequisites"
}
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<span class=\"c-course__prerequisites__title\">Préalables</span><div class=\"c-course__code -prerequisite\"><a aria-label=\"Consulter la fiche du cours : Méthodes de construction et productivité\" data-tooltip=\"Méthodes de construction et productivité\" href=\"#\"><span>CTN210</span></a></div><div class=\"c-course__code -prerequisite\"><a aria-label=\"Consulter la fiche du cours : Statique et dynamique\" data-tooltip=\"Statique et dynamique\" href=\"#\"><span>CTN248</span></a></div><div class=\"c-course__code -prerequisite\"><a aria-label=\"Consulter la fiche du cours : Résistance des matériaux\" data-tooltip=\"Résistance des matériaux\" href=\"#\"><span>CTN318</span></a></div>", 4)
const _hoisted_63 = [
  _hoisted_59
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Title "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString($props.block.coursesTitle), 1 /* TEXT */)
    ]),
    _createCommentVNode(" Tabs "),
    _createElementVNode("div", _hoisted_3, [
      ($props.block.coursesBlock.tabs.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["c-tabs-nav-mobile__button", { 'disabled': $data.selectedTab <= 0 }]),
                role: "tab",
                onClick: _cache[0] || (_cache[0] = $event => ($options.toggleTab($data.selectedTab - 1)))
              }, _hoisted_7, 2 /* CLASS */),
              _createElementVNode("button", {
                class: _normalizeClass(["c-tabs-nav-mobile__button", { 'disabled': $data.selectedTab >= $props.block.coursesBlock.tabs.length - 1 }]),
                role: "tab",
                onClick: _cache[1] || (_cache[1] = $event => ($options.toggleTab($data.selectedTab + 1)))
              }, _hoisted_9, 2 /* CLASS */)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.block.coursesBlock.tabs, (tab, tabIdx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: 'tabs-' + tabIdx,
                    class: _normalizeClass(["c-tabs-nav__item", { 'is-active': $data.selectedTab == tabIdx }]),
                    "aria-selected": $data.selectedTab == tabIdx,
                    role: "tab",
                    onClick: $event => ($options.toggleTab(tabIdx))
                  }, [
                    _createElementVNode("span", _hoisted_13, [
                      false
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Programme 7625"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("span", _hoisted_15, _toDisplayString(tab.title), 1 /* TEXT */)
                    ])
                  ], 10 /* CLASS, PROPS */, _hoisted_12))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Content "),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.block.coursesBlock.tabs, (tab, tabIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["c-tab-content__item", { 'is-active': $data.selectedTab == tabIdx }]),
            hidden: $data.selectedTab != tabIdx
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createCommentVNode(" Filters "),
                ($props.block.coursesBlock.tabs[$data.selectedTab].filters !== undefined && $props.block.coursesBlock.tabs[$data.selectedTab].filters.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h3", _hoisted_22, [
                          _createCommentVNode(" Get selected filters values "),
                          ($data.selectedFilter1 !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($props.block.coursesBlock.tabs[$data.selectedTab].filters[0].items.find(item => item.id ==
                                            $data.selectedFilter1).label), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($data.selectedFilter2 !== null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " / " + _toDisplayString($props.block.coursesBlock.tabs[$data.selectedTab].filters[1].items.find(item => item.id ==
                                            $data.selectedFilter2).label), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("select", {
                              class: "o-select -bordered -red",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.selectedFilter1) = $event))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.block.coursesBlock.tabs[$data.selectedTab].filters[0].items, (item, itemIdx) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: item.id
                                }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_29))
                              }), 256 /* UNKEYED_FRAGMENT */))
                            ], 512 /* NEED_PATCH */), [
                              [_vModelSelect, $data.selectedFilter1]
                            ]),
                            _hoisted_30
                          ]),
                          ($props.block.coursesBlock.tabs[$data.selectedTab].filters.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                ($props.block.coursesBlock.tabs[$data.selectedTab].filters.length > 1)
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 0,
                                      class: "o-select -bordered -red",
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.selectedFilter2) = $event))
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.block.coursesBlock.tabs[$data.selectedTab].filters[1].items, (item, itemIdx) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          ($options.blockHasFilter2(tab.blocks, item.id))
                                            ? (_openBlock(), _createElementBlock("option", {
                                                key: 0,
                                                value: item.id
                                              }, _toDisplayString(item.label), 9 /* TEXT, PROPS */, _hoisted_32))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    ], 512 /* NEED_PATCH */)), [
                                      [_vModelSelect, $data.selectedFilter2]
                                    ])
                                  : _createCommentVNode("v-if", true),
                                _hoisted_33
                              ]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.blocks, (blck, blockIdx) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    ($options.hasFilter(blck))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["c-course__row", { '--note': blck.isNote !== undefined && blck.isNote, '--course': blck.type == 'courses', '--text': blck.type == 'textField' }])
                        }, [
                          (blck.type == 'redactor')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["c-course__text", { '--note': blck.isNote !== undefined && blck.isNote }])
                              }, [
                                _createElementVNode("div", {
                                  class: "o-text",
                                  innerHTML: blck.value
                                }, null, 8 /* PROPS */, _hoisted_34)
                              ], 2 /* CLASS */))
                            : _createCommentVNode("v-if", true),
                          (blck.type == 'textField')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                (blck.style == 'title')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                      _createElementVNode("strong", null, _toDisplayString(blck.value), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                (blck.style == 'subtitle')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(blck.value), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (blck.type == 'courses')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blck.value, (entry, courseIdx) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    ($options.course(entry).url !== '#')
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: $options.course(entry).url,
                                          class: "c-course__header",
                                          "aria-label": "Consulter la fiche du cours : Éléments de construction de bâtiment"
                                        }, [
                                          (entry.course_id !== null)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "c-course__code",
                                                innerHTML: $options.course(entry).code + $options.getAsterix(entry)
                                              }, null, 8 /* PROPS */, _hoisted_41))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "c-course__code",
                                                innerHTML: entry.code + $options.getAsterix(entry)
                                              }, null, 8 /* PROPS */, _hoisted_42)),
                                          (entry.course_id !== null)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 2,
                                                class: "c-course__name",
                                                innerHTML: $options.course(entry).title
                                              }, null, 8 /* PROPS */, _hoisted_43))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 3,
                                                class: "c-course__name",
                                                innerHTML: entry.title
                                              }, null, 8 /* PROPS */, _hoisted_44))
                                        ], 8 /* PROPS */, _hoisted_40))
                                      : _createCommentVNode("v-if", true),
                                    ($options.course(entry).url == '#')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                          (entry.course_id !== null)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "c-course__code",
                                                innerHTML: $options.course(entry).code + $options.getAsterix(entry)
                                              }, null, 8 /* PROPS */, _hoisted_46))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 1,
                                                class: "c-course__code",
                                                innerHTML: entry.code + $options.getAsterix(entry)
                                              }, null, 8 /* PROPS */, _hoisted_47)),
                                          (entry.course_id !== null)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 2,
                                                class: "",
                                                innerHTML: $options.course(entry).title
                                              }, null, 8 /* PROPS */, _hoisted_48))
                                            : (_openBlock(), _createElementBlock("span", {
                                                key: 3,
                                                class: "",
                                                innerHTML: entry.title
                                              }, null, 8 /* PROPS */, _hoisted_49))
                                        ]))
                                      : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_50, [
                                      (entry.course_id !== null)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                            _createTextVNode(_toDisplayString($options.course(entry).credits) + " crédit", 1 /* TEXT */),
                                            ($options.course(entry).credits > 1)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode("s")
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : (entry.credits !== '')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(entry.credits), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entry.profiles, (profile, profileIdx) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                                          ($props.block.coursesBlock.profiles[profile] !== undefined)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                                                _createTextVNode(_toDisplayString($props.block.coursesBlock.profiles[profile].title) + " ", 1 /* TEXT */),
                                                _createElementVNode("span", _hoisted_54, [
                                                  _createElementVNode("span", _hoisted_55, [
                                                    _createElementVNode("span", _hoisted_56, _toDisplayString($props.block.coursesBlock.profiles[profile].title), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_57, _toDisplayString($props.block.coursesBlock.profiles[profile].description), 1 /* TEXT */)
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("v-if", true)
                                        ], 64 /* STABLE_FRAGMENT */))
                                      }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    false
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_63))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_17))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}